import { __extends } from "tslib";
var FetchError = /** @class */function (_super) {
  __extends(FetchError, _super);
  function FetchError(message, statusText, statusCode, body) {
    var _this = _super.call(this, message) || this;
    _this.name = 'FetchError';
    _this.statusText = statusText;
    _this.statusCode = statusCode;
    _this.body = body;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    }
    return _this;
  }
  return FetchError;
}(Error);
export { FetchError };